const paymentTypes = [
  { label: 'Pago a través del medio ya registrado', value: 'registered' },
  { label: 'Efectivo', value: 'cash' }
];

export default paymentTypes;
